function initDragDrop2dQuizObjectDisposal() {
    Q3.Events.listen("delete_start", removeReferences);
}

function removeReferences() {
    let uuid = Q3.selected && Q3.selected.uuid;
    if (!uuid) {
        return;
    }

    for (let { slideQuiz: { dragDrop2dQuiz: { images, regions } } } of Q3.data.slides.filter(s => s.slideQuiz)) {
        let imageIndex = images.findIndex(({ image }) => image === uuid);
        if (imageIndex !== -1) {
            images.splice(imageIndex, 1);
        }

        for (let { regions: imageRegions } of images) {
            removeValueFromArray(imageRegions, uuid);
        }

        removeValueFromArray(regions, uuid);
    }
}

function removeValueFromArray(array, value) {
    let index = array.indexOf(value);
    if (index !== -1) {
        array.splice(index, 1);
    }
}

export default initDragDrop2dQuizObjectDisposal;
